module.exports = __webpack_public_path__ + "static/media/poster@2x.f5ab7bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poster@2x.png
// module id = 66
// module chunks = 0